import React from 'react';

/**
 * ChartEmpty — "No data" empty state for chart areas.
 * Two modes: filtered-empty (no data in range) vs true-empty (first-run CTA).
 */
export default function ChartEmpty({ height = 300, filtered = true, entityName = 'data', onAction }) {
  const title = filtered
    ? 'No data in this range'
    : `Create your first ${entityName}`;
  const subtitle = filtered
    ? 'Try adjusting the period or filters'
    : `Once you have ${entityName}, charts will appear here`;

  return (
    <div
      style={{
        width: '100%',
        height,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 3,
        border: '1px dashed var(--color-border)',
        background: 'var(--neutral-50)',
        gap: 8,
        padding: 24,
      }}
    >
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" style={{ opacity: 0.4 }}>
        <rect x="4" y="20" width="8" height="24" rx="2" fill="currentColor" />
        <rect x="16" y="12" width="8" height="32" rx="2" fill="currentColor" />
        <rect x="28" y="16" width="8" height="28" rx="2" fill="currentColor" />
        <rect x="40" y="8" width="4" height="36" rx="2" fill="currentColor" />
      </svg>
      <p style={{
        font: 'var(--text-h3)',
        color: 'var(--color-text-default)',
        margin: 0,
        textAlign: 'center',
      }}>
        {title}
      </p>
      <p style={{
        fontSize: 14,
        color: 'var(--color-text-muted)',
        margin: 0,
        textAlign: 'center',
      }}>
        {subtitle}
      </p>
      {!filtered && onAction && (
        <button
          onClick={onAction}
          style={{
            marginTop: 12,
            padding: '8px 16px',
            background: 'var(--color-action-primary)',
            color: 'var(--color-surface)',
            border: 'none',
            borderRadius: 3,
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          Get Started
        </button>
      )}
    </div>
  );
}
